<div class="sidebar-form" #sidebar>
  <app-search-input
    [placeholder]="'widget-sidebar.search.placeholder' | translate"
    (inputChanged)="handleInputChange($event)"
    #widgetInput
  ></app-search-input>

  <div class="select-wrapper">
    <span>{{ "widget-sidebar.label.show" | translate }}:</span>
    <sui-combobox
      [options]="groupOptions"
      [ngModel]="currentGroupId"
      (ngModelChange)="currentGroupId = $event; onOptionChange($event)"
      [dropdownContainer]="dropdownBoundary"
    ></sui-combobox>
  </div>

  <sui-checkbox
    class="enable-preview-label"
    [(ngModel)]="pivotableOnly"
    [ngModelOptions]="{ standalone: true }"
    (checkedChange)="onPivotableToggle()"
  >
    {{ "widget-sidebar.controls-section.pivotable-only" | translate }}
  </sui-checkbox>
  @if (objectClassId == nomObjectClass.DASHBOARD) {
    <div class="preview-datasource-select">
      <div>{{ "widget-sidebar.label.preview-datasource" | translate }}</div>
      <sui-combobox
        [options]="(feedOptions$ | async) ?? []"
        [compareWith]="compareFeed"
        [ngModel]="defaultPreviewFeed"
        (ngModelChange)="
          defaultPreviewFeed = $event; defaultPreviewFeedChange()
        "
        [dropdownContainer]="dropdownBoundary"
      ></sui-combobox>
    </div>
  }
  <div class="create-section">
    <sui-button
      variant="primary"
      [disabled]="!previewWidget"
      (click)="createWidget()"
    >
      {{ "picker-widgets.button.create" | translate }}
    </sui-button>

    <sui-checkbox
      class="enable-preview-label"
      [(ngModel)]="enablePreview"
      [ngModelOptions]="{ standalone: true }"
    >
      {{ "widget-sidebar.controls-section.enable-preview" | translate }}
    </sui-checkbox>
  </div>
</div>
<div class="widget-list-content">
  <div class="preset-card-container">
    @if (widgetPresetsLoading$ | async) {
      <app-loading></app-loading>
    }
    @if (widgetPresetsFiltered.length > 0) {
      @for (
        widgetPreset of widgetPresetsFiltered | sort: "display_order";
        track trackByFn($index, widgetPreset)
      ) {
        <app-widget-preset-card
          [widgetPreset]="widgetPreset"
          [highlight]="searchString"
          [selectedPresetId]="selectedPresetId"
          [selectedChartTypeId]="selectedChartTypeId"
          [dataSourceObjectId]="getDataSourceObjectId()"
          [dataSourceObjectClassId]="getDataSourceObjectClassId()"
          (onWidgetPreview)="onWidgetPreview($event)"
          (onWidgetCreate)="onWidgetCreate($event)"
        ></app-widget-preset-card>
      }
    } @else {
      <!-- Content to display when widgetPresetsFiltered.length is 0 -->
      <p>{{ "widget-sidebar.message.no-presets-available" | translate }}</p>
    }
  </div>
</div>

@if (showPreview$ | async) {
  <app-widget-preview-popup
    #previewPopup
    [style.position]="'fixed'"
    [style.top.px]="popupTop"
    [style.left.px]="popupLeft"
    [style.z-index]="ZIndex.DIALOG"
    [hidden]="!enablePreview"
    [rtl]="rtl"
    [widget]="previewWidget"
    [isLoading]="previewIsLoading"
    [width]="currentPopupWidth"
    [height]="currentPopupHeight"
    (close)="closeWidgetPreviewPopup()"
    (dock)="dockWidgetPreviewPopup()"
    cdkDrag
    cdkDragBoundary="body"
    [cdkDragFreeDragPosition]="dragPosition"
    (cdkDragStarted)="onDragStarted()"
    (cdkDragMoved)="onDragMoved($event)"
    (cdkDragEnded)="onDragEnded()"
  ></app-widget-preview-popup>
}
